import styleConstants from './variables.module.scss';
import { FillsGraphLegendStatus } from 'widgets/fillsGraph/legendStatus';
import {
    CompanionChartVisibility,
    CompanionChartVisibilityStatus,
    isThereACompanionChartVisible,
} from 'widgets/fillsGraph/companionChartVisibility';
import { FillsChartType } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';

const companionChartCollapsedHeight = parseInt(
    styleConstants.companionChartCollapsedHeight
);

export const legendHeight = 18;

export function calculateChartHeights(
    height: number,
    companionChartVisibility: CompanionChartVisibility[],
    isOrderFillsVisible: boolean,
    legendStatus: FillsGraphLegendStatus,
    dockPercentage: number
) {
    const haveCompanionChart = isThereACompanionChartVisible(
        companionChartVisibility
    );

    const separatorHeight = 4;
    const mainPanelHeight = !isOrderFillsVisible
        ? 0
        : !haveCompanionChart
        ? height
        : (height * (100 - dockPercentage)) / 100 - separatorHeight;

    let orderFillsHeight =
        !isOrderFillsVisible || legendStatus.allOrderFillsHidden
            ? mainPanelHeight
            : mainPanelHeight - legendHeight;

    if (isOrderFillsVisible && haveCompanionChart) {
        orderFillsHeight = orderFillsHeight - 18;
    }

    const companionChartsHeight =
        height - mainPanelHeight - (isOrderFillsVisible ? separatorHeight : 0);

    const companionChartHeights = computeCompanionChartsHeights(
        companionChartVisibility,
        legendStatus,
        companionChartsHeight
    );

    return {
        mainPanelHeight,
        companionChartsHeight,
        orderFillsHeight,

        ...companionChartHeights,
    };
}

function computeCompanionChartsHeights(
    companionChartVisibility: CompanionChartVisibility[],
    legendStatus: FillsGraphLegendStatus,
    companionChartsHeight: number
) {
    const fullyVisibleCompanionCharts = companionChartVisibility.filter(
        (v) => v.visibility === CompanionChartVisibilityStatus.Visible
    ).length; // i.e. not hidden, not collapsed

    const nCollapsedCompanionCharts = companionChartVisibility.filter(
        (v) => v.visibility === CompanionChartVisibilityStatus.Collapsed
    ).length;

    const collapsedChartHeights =
        companionChartCollapsedHeight * nCollapsedCompanionCharts;
    const companionChartHeight =
        fullyVisibleCompanionCharts > 0
            ? (companionChartsHeight - collapsedChartHeights) /
              fullyVisibleCompanionCharts
            : 0;

    const {
        height: expectedVsActualHeight,
        chartHeight: expectedVsActualChartHeight,
    } = computeCompanionChartHeights(
        FillsChartType.ExpectedVsActual,
        'allExpectedVsActualHidden'
    );

    const {
        height: percentageOfMarketVolumeHeight,
        chartHeight: percentageOfMarketVolumeChartHeight,
    } = computeCompanionChartHeights(
        FillsChartType.PercentageOfMarketVolume,
        'allPercentageOfMarketVolumeHidden'
    );

    const { height: plHeight, chartHeight: plChartHeight } =
        computeCompanionChartHeights(FillsChartType.PnL, 'allPlChartHidden');

    const {
        height: performanceVsIndexHeight,
        chartHeight: performanceVsIndexChartHeight,
    } = computeCompanionChartHeights(
        FillsChartType.PerformanceVsIndex,
        'allPerformanceVsIndexChartHidden'
    );

    return {
        expectedVsActualHeight,
        expectedVsActualChartHeight,
        percentageOfMarketVolumeHeight,
        percentageOfMarketVolumeChartHeight,
        plHeight,
        plChartHeight,
        performanceVsIndexHeight,
        performanceVsIndexChartHeight,
    };

    function computeCompanionChartHeights(
        type: FillsChartType,
        allHidden: keyof FillsGraphLegendStatus
    ) {
        const isCollapsed =
            companionChartVisibility.find((c) => c.type === type)!
                .visibility === CompanionChartVisibilityStatus.Collapsed;
        const height = isCollapsed ? legendHeight : companionChartHeight;
        const chartHeight = legendStatus[allHidden]
            ? companionChartHeight
            : companionChartHeight - legendHeight;

        return { height, chartHeight };
    }
}
